const unpauseTypes = {
  unpause5: 'unpause5', // $5 off
  unpause50: 'unpause50', // 50% off
  unpausefree: 'unpausefree', // 1 month free
}


export default unpauseTypes
